module.exports = __webpack_public_path__ + "static/media/moscow.5be1ce42.png";